// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TradeMessageProcessor } from './TradeMessageProcessor';
import { DirectModifyTradeMessage } from '@shared/utils/DirectMessages/DirectModifyTradeMessage';
export class ModifyTradeMessageProcessor extends TradeMessageProcessor {
    decode(fs) {
        return [this.decodeMessage(new DirectModifyTradeMessage(), fs)];
    }
}
